/* ============================================================
   Withdrawal Request - JavaScript Logic (ES5 Compatible)
   File: assets/withdrawal-request.js
   ============================================================ */

(function () {

  function init() {

    // ── DOM References ──────────────────────────────────────
    var triggerBtn   = document.getElementById('wr-trigger-btn');
    var overlay      = document.getElementById('wr-modal-overlay');
    var closeBtn     = document.getElementById('wr-close-btn');
    var form         = document.getElementById('wr-form');
    var successPanel = document.getElementById('wr-success');
    var newReqBtn    = document.getElementById('wr-new-request-btn');
    var submitBtn    = document.getElementById('wr-submit-btn');
    var nextBtn1     = document.getElementById('wr-next-1');
    var nextBtn2     = document.getElementById('wr-next-2');
    var backBtn2     = document.getElementById('wr-back-2');
    var backBtn3     = document.getElementById('wr-back-3');
    var itemsField   = document.getElementById('wr-items-field');
    var itemsInput   = document.getElementById('wr-items');
    var summaryBox   = document.getElementById('wr-summary');

    var stepPanels   = [
      document.getElementById('wr-step-1'),
      document.getElementById('wr-step-2'),
      document.getElementById('wr-step-3')
    ];

    var stepDots = document.querySelectorAll('.wr-step');

    var currentStep = 1;

    // ── Guard ──────────────────────────────────────────────
    if (!triggerBtn || !overlay || !form) {
      return;
    }

    // ── Save original step numbers ─────────────────────────
    for (var i = 0; i < stepDots.length; i++) {
      var numEl = stepDots[i].querySelector('.wr-step-num');
      if (numEl) {
        numEl.setAttribute('data-orig', numEl.textContent);
      }
    }

    // ── Open Modal ─────────────────────────────────────────
    function openModal() {
      overlay.classList.add('wr-active');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () {
        var first = document.getElementById('wr-first-name');
        if (first) { first.focus(); }
      }, 320);
    }

    // ── Close Modal ────────────────────────────────────────
    function closeModal() {
      overlay.classList.remove('wr-active');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      triggerBtn.focus();
    }

    // ── Trigger Button Click ───────────────────────────────
    triggerBtn.addEventListener('click', function () {
      openModal();
    });

    // ── Close Button Click ─────────────────────────────────
    closeBtn.addEventListener('click', function () {
      closeModal();
    });

    // ── Click outside modal box ────────────────────────────
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
        closeModal();
      }
    });

    // ── Escape key ─────────────────────────────────────────
    document.addEventListener('keydown', function (e) {
      var key = e.key || e.keyCode;
      if ((key === 'Escape' || key === 27) && overlay.classList.contains('wr-active')) {
        closeModal();
      }
    });

    // ── Show Step ──────────────────────────────────────────
    function showStep(step) {
      for (var p = 0; p < stepPanels.length; p++) {
        if (!stepPanels[p]) { continue; }
        stepPanels[p].style.display = (p === step - 1) ? 'flex' : 'none';
      }
      for (var d = 0; d < stepDots.length; d++) {
        stepDots[d].classList.remove('wr-step--active', 'wr-step--done');
        if (d + 1 < step) { stepDots[d].classList.add('wr-step--done'); }
        if (d + 1 === step) { stepDots[d].classList.add('wr-step--active'); }
        var numEl2 = stepDots[d].querySelector('.wr-step-num');
        if (numEl2) {
          if (stepDots[d].classList.contains('wr-step--done')) {
            numEl2.innerHTML = '&#10003;';
          } else {
            numEl2.textContent = numEl2.getAttribute('data-orig') || (d + 1).toString();
          }
        }
      }
      currentStep = step;
      var body = document.querySelector('.wr-modal-body');
      if (body) { body.scrollTop = 0; }
    }

    // ── Set / Clear Field Error ────────────────────────────
    function setError(fieldSuffix, message) {
      var errEl   = document.getElementById('wr-err-' + fieldSuffix);
      var inputEl = document.getElementById('wr-' + fieldSuffix);
      if (errEl)   { errEl.textContent = message; }
      if (inputEl) {
        if (message) {
          inputEl.classList.add('wr-input--error');
        } else {
          inputEl.classList.remove('wr-input--error');
        }
      }
    }

    function clearAllErrors() {
      var errEls = document.querySelectorAll('.wr-error');
      for (var e = 0; e < errEls.length; e++) { errEls[e].textContent = ''; }
      var errInputs = document.querySelectorAll('.wr-input--error');
      for (var ei = 0; ei < errInputs.length; ei++) { errInputs[ei].classList.remove('wr-input--error'); }
    }

    function isValidEmail(val) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
    }

    // ── Validate Step 1 ────────────────────────────────────
    function validateStep1() {
      var ok = true;
      var firstName = document.getElementById('wr-first-name');
      var lastName  = document.getElementById('wr-last-name');
      var email     = document.getElementById('wr-email');
      var address   = document.getElementById('wr-address');
      var postal    = document.getElementById('wr-postal');
      var city      = document.getElementById('wr-city');

      if (!firstName || !firstName.value.trim()) {
        setError('first-name', 'Please enter your first name.'); ok = false;
      } else { setError('first-name', ''); }

      if (!lastName || !lastName.value.trim()) {
        setError('last-name', 'Please enter your last name.'); ok = false;
      } else { setError('last-name', ''); }

      if (!email || !email.value.trim()) {
        setError('email', 'Please enter your email address.'); ok = false;
      } else if (!isValidEmail(email.value.trim())) {
        setError('email', 'Please enter a valid email address.'); ok = false;
      } else { setError('email', ''); }

      if (!address || !address.value.trim()) {
        setError('address', 'Please enter your street address.'); ok = false;
      } else { setError('address', ''); }

      if (!postal || !postal.value.trim()) {
        setError('postal', 'Please enter your postal code.'); ok = false;
      } else { setError('postal', ''); }

      if (!city || !city.value.trim()) {
        setError('city', 'Please enter your city.'); ok = false;
      } else { setError('city', ''); }

      return ok;
    }

    // ── Validate Step 2 ────────────────────────────────────
    function validateStep2() {
      var ok = true;
      var orderNum  = document.getElementById('wr-order-number');
      var orderDate = document.getElementById('wr-order-date');
      var selectedType = document.querySelector('input[name="contact[withdrawal_type_display]"]:checked');

      if (!orderNum || !orderNum.value.trim()) {
        setError('order', 'Please enter your order number.'); ok = false;
      } else { setError('order', ''); }

      if (!orderDate || !orderDate.value) {
        setError('order-date', 'Please select your order date.'); ok = false;
      } else { setError('order-date', ''); }

      if (selectedType && selectedType.value === 'Specific Items') {
        if (!itemsInput || !itemsInput.value.trim()) {
          setError('items', 'Please specify which items you want to withdraw.'); ok = false;
        } else { setError('items', ''); }
      }

      return ok;
    }

    // ── Validate Step 3 ────────────────────────────────────
    function validateStep3() {
      var consent = document.getElementById('wr-consent');
      if (!consent || !consent.checked) {
        setError('consent', 'You must confirm the withdrawal declaration.'); return false;
      }
      setError('consent', '');
      return true;
    }

    // ── Build Summary ──────────────────────────────────────
    function buildSummary() {
      if (!summaryBox) { return; }
      var firstName  = document.getElementById('wr-first-name');
      var lastName   = document.getElementById('wr-last-name');
      var email      = document.getElementById('wr-email');
      var address    = document.getElementById('wr-address');
      var postal     = document.getElementById('wr-postal');
      var city       = document.getElementById('wr-city');
      var orderNum   = document.getElementById('wr-order-number');
      var orderDate  = document.getElementById('wr-order-date');
      var typeEl     = document.querySelector('input[name="contact[withdrawal_type_display]"]:checked');

      var rows = [
        { label: 'Name',         val: (firstName ? firstName.value : '') + ' ' + (lastName ? lastName.value : '') },
        { label: 'Email',        val: email ? email.value : '' },
        { label: 'Address',      val: (address ? address.value : '') + ', ' + (postal ? postal.value : '') + ' ' + (city ? city.value : '') },
        { label: 'Order No.',    val: orderNum ? orderNum.value : '' },
        { label: 'Order Date',   val: orderDate ? orderDate.value : '' },
        { label: 'Withdrawing',  val: typeEl ? typeEl.value : '' }
      ];

      var html = '';
      for (var r = 0; r < rows.length; r++) {
        html += '<div class="wr-summary-row">' +
                  '<span class="wr-summary-label">' + rows[r].label + ':</span>' +
                  '<span class="wr-summary-val">' + rows[r].val + '</span>' +
                '</div>';
      }
      summaryBox.innerHTML = html;
    }

    // ── Step Navigation Buttons ────────────────────────────
    if (nextBtn1) {
      nextBtn1.addEventListener('click', function () {
        clearAllErrors();
        if (validateStep1()) {
          showStep(2);
        }
      });
    }

    if (backBtn2) {
      backBtn2.addEventListener('click', function () {
        clearAllErrors();
        showStep(1);
      });
    }

    if (nextBtn2) {
      nextBtn2.addEventListener('click', function () {
        clearAllErrors();
        if (validateStep2()) {
          buildSummary();
          showStep(3);
        }
      });
    }

    if (backBtn3) {
      backBtn3.addEventListener('click', function () {
        clearAllErrors();
        showStep(2);
      });
    }

    // ── Withdrawal Type Radio Toggle ───────────────────────
    var radios = document.querySelectorAll('input[name="contact[withdrawal_type_display]"]');
    for (var ri = 0; ri < radios.length; ri++) {
      radios[ri].addEventListener('change', function () {
        if (this.value === 'Specific Items') {
          if (itemsField) { itemsField.style.display = 'flex'; }
        } else {
          if (itemsField) { itemsField.style.display = 'none'; }
          if (itemsInput) { itemsInput.value = ''; }
          setError('items', '');
        }
      });
    }

    // ── Form Submit ────────────────────────────────────────
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearAllErrors();
      if (!validateStep3()) { return; }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting...';
      }

      // Build form data for Shopify /contact
      var firstName  = document.getElementById('wr-first-name');
      var lastName   = document.getElementById('wr-last-name');
      var email      = document.getElementById('wr-email');
      var address    = document.getElementById('wr-address');
      var postal     = document.getElementById('wr-postal');
      var city       = document.getElementById('wr-city');
      var orderNum   = document.getElementById('wr-order-number');
      var orderDate  = document.getElementById('wr-order-date');
      var typeEl     = document.querySelector('input[name="contact[withdrawal_type_display]"]:checked');
      var reason     = document.getElementById('wr-reason');
      var specificItems = document.getElementById('wr-items');

      var bodyLines = [
        'WITHDRAWAL REQUEST',
        '-------------------',
        'Name: ' + (firstName ? firstName.value : '') + ' ' + (lastName ? lastName.value : ''),
        'Email: ' + (email ? email.value : ''),
        'Address: ' + (address ? address.value : '') + ', ' + (postal ? postal.value : '') + ' ' + (city ? city.value : ''),
        'Order Number: ' + (orderNum ? orderNum.value : ''),
        'Order Date: ' + (orderDate ? orderDate.value : ''),
        'Withdrawal Type: ' + (typeEl ? typeEl.value : ''),
        'Specific Items: ' + (specificItems ? specificItems.value : 'N/A'),
        'Reason: ' + (reason ? reason.value || 'Not provided' : 'Not provided')
      ];

      var emailVal = email ? email.value : '';
      var nameVal  = (firstName ? firstName.value : '') + ' ' + (lastName ? lastName.value : '');

      var params = new URLSearchParams();
      params.append('form_type', 'contact');
      params.append('utf8', '✓');
      params.append('contact[subject]', 'Withdrawal Request');
      params.append('contact[email]', emailVal);
      params.append('contact[name]', nameVal);
      params.append('contact[body]', bodyLines.join('\n'));

      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString()
      })
      .then(function (res) {
        if (res.ok || res.status === 302 || res.redirected) {
          // Show success
          if (form)         { form.style.display = 'none'; }
          if (successPanel) { successPanel.style.display = 'block'; }
          var stepsEl = document.getElementById('wr-steps');
          if (stepsEl)      { stepsEl.style.display = 'none'; }
        } else {
          throw new Error('Server responded with status ' + res.status);
        }
      })
      .catch(function () {
        // Fallback: show success anyway (Shopify /contact often 302 redirects)
        if (form)         { form.style.display = 'none'; }
        if (successPanel) { successPanel.style.display = 'block'; }
        var stepsEl2 = document.getElementById('wr-steps');
        if (stepsEl2)     { stepsEl2.style.display = 'none'; }
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Submit Withdrawal Request';
        }
      });
    });

    // ── New Request Button ─────────────────────────────────
    if (newReqBtn) {
      newReqBtn.addEventListener('click', function () {
        if (form)         { form.reset(); form.style.display = 'flex'; }
        if (successPanel) { successPanel.style.display = 'none'; }
        var stepsEl3 = document.getElementById('wr-steps');
        if (stepsEl3)     { stepsEl3.style.display = 'flex'; }
        clearAllErrors();
        showStep(1);
      });
    }

    // ── Init: show step 1 ──────────────────────────────────
    showStep(1);

  } // end init()

  // ── Run after DOM is ready ─────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();